/*
 * Doel ── PDP の号数（サイズ）選択チップ
 * --------------------------------------------------------------------
 * v3 PDP 仕様：受け取り方法・日時はカートで選ぶ。PDP では Variant（号数）だけ選ぶ。
 * チップ（button[role=radio]）クリックで：
 *   - .is-on / aria-checked を移動
 *   - 価格表示（.doel-pdp__price）を選択 Variant の価格に更新
 *   - フォーム送信用の hidden input（name="id" ref="variantId"）を更新 → AJAX 追加が正しい Variant を送る
 *   - 売り切れ Variant 選択時はカートボタンを無効化
 *   - のし枠の出し入れと、誕生日枠への doel:variant-change 通知（2026-08-21）
 *   - URL ?variant= を書き換え（共有・リロード耐性）
 * product-form-component（§27.2）が ref="variantId" の value を読むため、hidden input を1つに統一している。
 */
(function () {
  'use strict';

  function init() {
    var group = document.querySelector('[data-doel-variants]');
    if (!group) return;
    var chips = group.querySelectorAll('.doel-pdp__variant');
    if (!chips.length) return;

    var input = document.querySelector('[data-doel-variant-input]');
    var priceEl = document.querySelector('.doel-pdp__price');
    var buyBtn = document.querySelector('.doel-pdp__buy [name="add"]');

    // バリアント連動ギャラリー（2026-08-14、2026-09-28 改）。
    // 各サムネイルは data-variant-ids に紐づくバリアントを持つ。
    // 2026-09-28：以前は選んだバリアントの写真だけを残し、共通の写真・他のバリアントの写真を隠していた
    // （写真が 1 枚ならサムネイル列ごと消えた）。高原さん・wai さんの指摘で、写真は常に全部選べるようにし、
    // 選んだバリアントの写真を主画像に出して、サムネイル列の先頭へ寄せる形に改めた。
    var mainImg = document.querySelector('[data-doel-gallery-main]');
    var thumbsWrap = document.querySelector('[data-doel-thumbs]');
    var thumbs = thumbsWrap ? Array.prototype.slice.call(thumbsWrap.querySelectorAll('.doel-pdp__thumb')) : [];

    function syncGallery(vid) {
      if (!mainImg || !thumbs.length || !vid) return;
      // featured：管理画面でこのバリアントに登録した写真。mine：それ以外でこのバリアントに属する写真（仮画像の 02・03）
      var featured = [], mine = [], rest = [];
      for (var i = 0; i < thumbs.length; i++) {
        var ids = (thumbs[i].getAttribute('data-variant-ids') || '').split(',');
        var fids = (thumbs[i].getAttribute('data-variant-featured') || '').split(',');
        thumbs[i].hidden = false;
        thumbs[i].classList.remove('is-on');
        if (fids.indexOf(vid) > -1) featured.push(thumbs[i]);
        else (ids.indexOf(vid) > -1 ? mine : rest).push(thumbs[i]);
      }
      mine = featured.concat(mine);
      // このバリアントに紐づく写真がない → 並びも主画像もそのまま
      if (!mine.length) return;
      // 登録写真を主画像にして先頭へ、残りは元の順（Shopify の並び順）のまま後ろへ
      var order = mine.concat(rest);
      for (var k = 0; k < order.length; k++) thumbsWrap.appendChild(order[k]);
      mainImg.src = mine[0].getAttribute('data-full');
      mine[0].classList.add('is-on');
      if (thumbsWrap.scrollTo) thumbsWrap.scrollTo({ left: 0, top: 0 });
    }

    // アレルゲン表示をバリアントに追随させる（2026-08-14）。
    // 食品表示なので、味・入数を切り替えたら中身も入れ替わらなければならない
    // （バニラサブレは卵あり、チーズサブレは卵なし）。
    var allergenBox = document.querySelector('[data-doel-allergens]');

    function syncAllergens(csv) {
      if (!allergenBox || csv === null) return;
      var ul = allergenBox.querySelector('.doel-allergen-accordion__tags');
      if (!ul) return;
      var items = (csv || '').split('・').filter(function (s) { return s.trim() !== ''; });
      if (!items.length) return;
      ul.innerHTML = '';
      for (var i = 0; i < items.length; i++) {
        var li = document.createElement('li');
        li.className = 'doel-allergen-accordion__tag';
        li.textContent = items[i].trim();
        ul.appendChild(li);
      }
    }

    /*
     * のし枠・誕生日枠をバリアントに追随させる（2026-08-21）。
     * サクリスタンのように「単品はのし不可／箱入りは可」と割れる商品があり、
     * 商品単位の値（1 つでも可なら true の集計）だけで出していると、
     * 単品を選んでも のし枠が出たままになる。
     * 誕生日枠のほうは doel-pdp-birthday.liquid 側の script が同じイベントを受ける。
     */
    var giftGroup = document.querySelector('[data-doel-gift-group]');

    /*
     * のし枠を閉じるときは選択も消す。画面に見えていない選択をカートに載せないため。
     * 中身は下の v4 スクリプトの resetGift（別の IIFE なのでイベントで頼む。同期で走る）。
     */
    function clearGift() {
      if (giftGroup) giftGroup.dispatchEvent(new CustomEvent('doel:gift-reset'));
    }

    function syncGift(chip) {
      var giftable = chip.getAttribute('data-variant-giftable') !== 'false';
      if (giftGroup) {
        if (!giftable && !giftGroup.hidden) clearGift();
        /* のし不可のバリアントから戻ったときは、最初の表示と同じ選択に戻す（2026-10-06） */
        if (giftable && giftGroup.hidden) giftGroup.dispatchEvent(new CustomEvent('doel:gift-default'));
        giftGroup.hidden = !giftable;
      }
      document.dispatchEvent(new CustomEvent('doel:variant-change', {
        detail: {
          id: chip.getAttribute('data-variant-id'),
          giftable: giftable,
          candleFree: chip.getAttribute('data-variant-candle-free') || '',
          plateFree: chip.getAttribute('data-variant-plate-free') || ''
        }
      }));
    }

    function select(chip) {
      for (var i = 0; i < chips.length; i++) {
        chips[i].classList.remove('is-on');
        chips[i].setAttribute('aria-checked', 'false');
      }
      chip.classList.add('is-on');
      chip.setAttribute('aria-checked', 'true');

      var vid = chip.getAttribute('data-variant-id');
      if (input && vid) input.value = vid;
      syncGallery(vid);
      syncAllergens(chip.getAttribute('data-variant-allergens'));
      syncGift(chip);

      var price = chip.getAttribute('data-variant-price');
      if (priceEl && price) priceEl.textContent = price;
      // クリスマスの品の店頭価格（比較価格）も追随させる（2026-11-02）
      var compareEl = document.querySelector('[data-doel-compare]');
      var compare = chip.getAttribute('data-variant-compare');
      if (compareEl && compare) compareEl.textContent = compare;

      var available = chip.getAttribute('data-variant-available') === 'true';
      if (buyBtn) {
        buyBtn.disabled = !available;
        // 文言はボタンの data 属性から（クリスマスの受付前は「11月9日（月）から予約できます」）
        buyBtn.textContent = available
          ? (buyBtn.getAttribute('data-label-ok') || 'カートに入れる　→')
          : (buyBtn.getAttribute('data-label-ng') || '売り切れ');
      }

      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', vid);
        window.history.replaceState({}, '', u);
      } catch (e) { /* noop */ }
    }

    for (var j = 0; j < chips.length; j++) {
      (function (chip) {
        chip.addEventListener('click', function () { select(chip); });
        chip.addEventListener('keydown', function (e) {
          // ←→ で前後のチップへ（radiogroup の振る舞い）
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            var arr = Array.prototype.slice.call(chips);
            var idx = arr.indexOf(chip);
            var next = (e.key === 'ArrowRight' || e.key === 'ArrowDown')
              ? arr[(idx + 1) % arr.length]
              : arr[(idx - 1 + arr.length) % arr.length];
            next.focus();
            select(next);
          }
        });
      })(chips[j]);
    }

    // 初期表示：アレルゲンはいま選ばれているバリアントに合わせる。
    // 写真は ?variant= 付きで開いたときだけ合わせる（2026-09-28）。指定なしで開いたときは、
    // 一覧のサムネイルと同じ商品のメイン写真のまま見せる（先頭バリアントの写真に差し替えない）。
    var hasVariantParam = /[?&]variant=/.test(window.location.search);
    for (var k = 0; k < chips.length; k++) {
      if (chips[k].classList.contains('is-on')) {
        if (hasVariantParam) syncGallery(chips[k].getAttribute('data-variant-id'));
        syncAllergens(chips[k].getAttribute('data-variant-allergens'));
        break;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/*
 * v4（2026-07-17）── PDP 追加スクリプト
 *  1. ギャラリー：サムネクリックで主写真を差し替え
 *  2. GIFT 集約枠：のし・包装チップ（単一選択 → hidden input）、
 *     空の line item property は送信時に除外
 *
 * 2026-08-14 改修（逢坂さん回答 2026-07-22、仕様書 §10）：
 *  - メッセージカードは承っていない → initCard を削除
 *  - のし表書きに「その他（自由記入）」を追加
 *  - のし選択中は 内のし/外のし・名入れ の行を表示し、包装を「付ける」に固定
 *    （のしを掛けるときは必ず包装、という店の運用に合わせる）
 */
(function () {
  'use strict';

  function initGallery() {
    var main = document.querySelector('[data-doel-gallery-main]');
    var wrap = document.querySelector('[data-doel-thumbs]');
    if (!main || !wrap) return;
    var thumbs = wrap.querySelectorAll('.doel-pdp__thumb');
    for (var i = 0; i < thumbs.length; i++) {
      (function (t) {
        t.addEventListener('click', function () {
          var full = t.getAttribute('data-full');
          if (!full) return;
          main.setAttribute('src', full);
          for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.remove('is-on');
          t.classList.add('is-on');
        });
      })(thumbs[i]);
    }
  }

  function initChipGroup(groupSel, inputSel) {
    var group = document.querySelector(groupSel);
    var input = document.querySelector(inputSel);
    if (!group || !input) return;
    var chips = group.querySelectorAll('.doel-gift-chip');
    for (var i = 0; i < chips.length; i++) {
      (function (chip) {
        chip.addEventListener('click', function () {
          for (var k = 0; k < chips.length; k++) {
            chips[k].classList.remove('is-on');
            chips[k].setAttribute('aria-checked', 'false');
          }
          chip.classList.add('is-on');
          chip.setAttribute('aria-checked', 'true');
          input.value = chip.getAttribute('data-value') || '';
          input.disabled = !input.value; /* 空の property はカートに載せない */
        });
      })(chips[i]);
    }
  }


  /*
   * のし枠の選択を全部消し、「希望しない」に戻して畳む。
   * バリアント切替でのし不可になったとき（clearGift）と、「希望しない」を押したときに使う。
   * バリアントが 1 つだけの商品では init() が途中で抜けるので、外に置いてある。
   */
  function resetGift(giftGroup) {
    if (!giftGroup) return;
    function reset(sel, value) {
      var el = giftGroup.querySelector(sel);
      if (el) { el.value = value; el.disabled = true; }
    }
    reset('[data-doel-noshi-input]', '');
    reset('[data-doel-noshi-style-input]', '内のし');
    reset('[data-doel-noshi-name-input]', '');
    reset('[data-doel-wrap-input]', '');
    reset('[data-doel-bags-input]', '');

    var otherText = giftGroup.querySelector('[data-doel-noshi-other-text]');
    if (otherText) { otherText.value = ''; otherText.hidden = true; }
    var nameInput = giftGroup.querySelector('[data-doel-noshi-name]');
    if (nameInput) nameInput.value = '';
    var details = giftGroup.querySelector('[data-doel-noshi-details]');
    if (details) details.hidden = true;

    /* チップは各行の先頭（＝「なし」「付けない」「内のし」「希望しない」）に戻す */
    var rows = ['[data-doel-noshi]', '[data-doel-wrap]', '[data-doel-noshi-style]', '[data-doel-bags]', '[data-doel-optin]'];
    for (var r = 0; r < rows.length; r++) {
      var row = giftGroup.querySelector(rows[r]);
      if (!row) continue;
      var cs = row.querySelectorAll('.doel-gift-chip');
      for (var c = 0; c < cs.length; c++) {
        cs[c].classList.toggle('is-on', c === 0);
        cs[c].setAttribute('aria-checked', c === 0 ? 'true' : 'false');
        cs[c].disabled = false; /* のし選択中に固定した包装チップの固定も解く */
      }
    }
    var panels = giftGroup.querySelectorAll('[data-doel-optin-panel]');
    for (var p = 0; p < panels.length; p++) panels[p].hidden = true;
  }

  /*
   * 「希望する」の初期の選択（2026-10-06）：おのし紙不要・包装 付ける・手提げ袋 付ける。
   * 最初の表示は liquid 側でこの状態にしてある。「希望する」を押し直したときと、
   * バリアント切替でのし枠がまた出たときに、ここで同じ状態に戻す。
   */
  function setGiftDefaults(giftGroup) {
    if (!giftGroup) return;
    resetGift(giftGroup);
    function pick(rowSel, value) {
      var row = giftGroup.querySelector(rowSel);
      if (!row) return;
      var cs = row.querySelectorAll('.doel-gift-chip');
      for (var c = 0; c < cs.length; c++) {
        var on = cs[c].getAttribute('data-value') === value;
        cs[c].classList.toggle('is-on', on);
        cs[c].setAttribute('aria-checked', on ? 'true' : 'false');
      }
    }
    pick('[data-doel-optin]', 'on');
    pick('[data-doel-wrap]', '付ける');
    pick('[data-doel-bags]', '付ける');
    var inputs = ['[data-doel-wrap-input]', '[data-doel-bags-input]'];
    for (var i = 0; i < inputs.length; i++) {
      var el = giftGroup.querySelector(inputs[i]);
      if (el) { el.value = '付ける'; el.disabled = false; }
    }
    var panels = giftGroup.querySelectorAll('[data-doel-optin-panel]');
    for (var p = 0; p < panels.length; p++) panels[p].hidden = false;
  }

  /*
   * 「希望しない」（2026-11-02）：選択を消して畳んだうえで、包装と手提げ袋だけは「付けない」として送る。
   * 各階の紙に「包装 不要」「手提げ袋 不要」と出すため（値が無いと、選ばなかったのか要らないのか紙で分からない）。
   * のし不可の品で枠ごと隠すとき（doel:gift-reset）は resetGift だけで、何も送らない。
   */
  function setGiftDeclined(giftGroup) {
    if (!giftGroup) return;
    resetGift(giftGroup);
    var inputs = ['[data-doel-wrap-input]', '[data-doel-bags-input]'];
    for (var i = 0; i < inputs.length; i++) {
      var el = giftGroup.querySelector(inputs[i]);
      if (el) { el.value = '付けない'; el.disabled = false; }
    }
  }

  /*
   * 「おのし紙・包装・手提げ袋」の問い（2026-09-22）。「希望する」で中の行を開き、
   * 「希望しない」で選択を消して畳む。
   */
  function initGiftOptin() {
    var group = document.querySelector('[data-doel-gift-group]');
    if (!group) return;
    /* バリアント切替でのし不可になったとき（上のスクリプトの clearGift）から呼ばれる */
    group.addEventListener('doel:gift-reset', function () { resetGift(group); });
    group.addEventListener('doel:gift-default', function () { setGiftDefaults(group); });
    /* 最初のバリアントがのし不可で枠が隠れているときは、隠れた初期の選択をカートに載せない */
    if (group.hidden) resetGift(group);
    var optin = group.querySelector('[data-doel-optin]');
    if (!optin) return;
    var chips = optin.querySelectorAll('.doel-gift-chip');
    for (var i = 0; i < chips.length; i++) {
      (function (chip) {
        chip.addEventListener('click', function () {
          if (chip.classList.contains('is-on')) return;
          if (chip.getAttribute('data-value') !== 'on') { setGiftDeclined(group); return; }
          setGiftDefaults(group);
        });
      })(chips[i]);
    }
  }

  /*
   * のし枠。表書きチップ（プリセット＋その他自由記入）を単一選択で hidden input へ。
   * のしが選ばれている間だけ 掛け方（内のし/外のし）と名入れの行を出し、
   * 包装チップを「付ける」に固定する（のしを掛けるときは必ず包装）。
   */
  function initNoshi() {
    var group = document.querySelector('[data-doel-noshi]');
    var hidden = document.querySelector('[data-doel-noshi-input]');
    if (!group || !hidden) return;
    var chips = group.querySelectorAll('.doel-gift-chip');
    var otherChip = group.querySelector('[data-doel-noshi-other]');
    var otherText = document.querySelector('[data-doel-noshi-other-text]');
    var details = document.querySelector('[data-doel-noshi-details]');
    var nameInput = document.querySelector('[data-doel-noshi-name]');
    var nameHidden = document.querySelector('[data-doel-noshi-name-input]');
    var styleHidden = document.querySelector('[data-doel-noshi-style-input]');
    var wrapGroup = document.querySelector('[data-doel-wrap]');
    var wrapHidden = document.querySelector('[data-doel-wrap-input]');
    var wrapChips = wrapGroup ? wrapGroup.querySelectorAll('.doel-gift-chip') : [];

    function markSelected(chip) {
      for (var k = 0; k < chips.length; k++) {
        chips[k].classList.remove('is-on');
        chips[k].setAttribute('aria-checked', 'false');
      }
      chip.classList.add('is-on');
      chip.setAttribute('aria-checked', 'true');
    }

    function lockWrap(active) {
      if (!wrapChips.length || !wrapHidden) return;
      if (active) {
        for (var k = 0; k < wrapChips.length; k++) {
          var on = wrapChips[k].getAttribute('data-value') === '付ける';
          wrapChips[k].classList.toggle('is-on', on);
          wrapChips[k].setAttribute('aria-checked', on ? 'true' : 'false');
          wrapChips[k].disabled = true;
        }
        wrapHidden.value = '付ける';
        wrapHidden.disabled = false;
      } else {
        /* 固定を解く。「付ける」の選択状態は保ったまま、お客様が変えられるようにする */
        for (var j = 0; j < wrapChips.length; j++) wrapChips[j].disabled = false;
      }
    }

    function sync() {
      var val = hidden.value;
      var active = !!val;
      hidden.disabled = !active;
      if (details) details.hidden = !active;
      if (styleHidden) styleHidden.disabled = !active;
      if (nameHidden) nameHidden.disabled = !active || !nameHidden.value;
      lockWrap(active);
    }

    for (var i = 0; i < chips.length; i++) {
      (function (chip) {
        chip.addEventListener('click', function () {
          markSelected(chip);
          if (chip === otherChip) {
            if (otherText) {
              otherText.hidden = false;
              hidden.value = otherText.value.trim();
              otherText.focus();
            }
          } else {
            if (otherText) otherText.hidden = true;
            hidden.value = chip.getAttribute('data-value') || '';
          }
          sync();
        });
      })(chips[i]);
    }

    if (otherText) {
      otherText.addEventListener('input', function () {
        hidden.value = otherText.value.trim();
        sync();
      });
    }

    if (nameInput && nameHidden) {
      nameInput.addEventListener('input', function () {
        nameHidden.value = nameInput.value.trim();
        nameHidden.disabled = !hidden.value || !nameHidden.value;
      });
    }

    sync();
  }

  /*
   * 購入数の上限（2026-10-12）。商品ページは 1 回押すごとに 1 個ずつカートに入る作りなので、
   * 押した瞬間にカートを読み、同じバリアントがすでに上限まで入っていれば止める。
   * 上限は商品の doel.max_qty（未設定は 99）。カートの数量欄は quantity-selector.liquid の max で止める。
   * Shopify プランには標準の上限機能がない（quantity_rule は B2B 用）。
   */
  function initQtyLimit() {
    var form = document.getElementById('doel-product-form');
    if (!form) return;
    var host = form.closest('product-form-component');
    var max = parseInt(host && host.getAttribute('data-doel-max-qty'), 10) || 99;
    var errEl = form.querySelector('[data-doel-qty-error]');
    var passing = false;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    /* Horizon（component.js）は document の capture で submit を拾うので、それより先に動く window の capture で受ける */
    window.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (passing) { passing = false; return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      var submitter = e.submitter;
      var input = form.querySelector('[data-doel-variant-input]');
      var vid = input ? String(input.value) : '';
      function go() {
        passing = true;
        if (submitter && form.requestSubmit) form.requestSubmit(submitter); else form.requestSubmit();
      }
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var inCart = 0;
          (cart.items || []).forEach(function (it) {
            if (String(it.variant_id) === vid) inCart += it.quantity;
          });
          if (inCart + 1 > max) {
            if (errEl) {
              errEl.textContent = 'この商品は 1 回のご注文で ' + max + ' 個までです（カートに ' + inCart + ' 個入っています）。';
              errEl.hidden = false;
            }
            return;
          }
          if (errEl) errEl.hidden = true;
          go();
        })
        .catch(go);
    }, true);
  }

  function initV4() {
    initQtyLimit();
    initGallery();
    initGiftOptin();
    initNoshi();
    initChipGroup('[data-doel-noshi-style]', '[data-doel-noshi-style-input]');
    initChipGroup('[data-doel-wrap]', '[data-doel-wrap-input]');
    /* 手提げ袋は 2026-09-22 に枚数の select から「付ける／付けない」のチップへ（大きさと枚数は店が決める） */
    initChipGroup('[data-doel-bags]', '[data-doel-bags-input]');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initV4);
  } else {
    initV4();
  }
})();
